import React, { useState } from "react";
import {
  Container,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
} from "@mui/material";

const questions = {
  english: {
    "0-3 months": [
      "Does your baby respond to loud sounds by smiling or startling?",
      "Does your baby respond to soft or gentle sounds like whispers?",
      "Does your baby respond to your voice by smiling or becoming quiet?",
      "Does your baby make sounds like ah... ah... ah ?",
      "Do your baby's eyes move towards the source of a sound?",
    ],
    "3-6 months": [
      "Does your baby locate sound correctly?",
      "Does your baby respond to his/her name when called?",
      "Does your baby make sounds like pa-pa-pa or ba-ba-ba?",
      "Does your baby respond to sound-producing toys?",

    ],
    "6-9 months": [
      "Can your baby differentiate between different sounds?",
      "Does your baby identify the direction of a sound and locate its source correctly?",
      "Does your baby combine vowels and consonants to make various sounds, such as ba-ba-ba?",
      "Does your baby respond to his/her name when called?",
      "Does your baby respond to the voices of others?",
    ],
    "9-12 months": [
      "Does your baby recognize objects when their names are mentioned?",
      "Does your baby use a word to name objects?",
      "Does your baby follow simple instructions spoken in a phrase/sentence?",
    ],
    "1-2 years": [
      "Does your child understand the names of various objects?",
      "Does your child form sentences by combining one or two words?",
      "Does your child recognize and respond when their name is called from another room?",
    ],
    "2-3 years": [
      "Does your child understand and follow the instructions given in 2-3 sentences?",
      "Does your child respond when their name is called from a distance?",
      "Does your child use 2-3 words to form sentences?",
    ],
  },
  kannada: {
    "0-3 months": [
      "ನಿಮ್ಮ ಮಗುವು ಶಬ್ದಕ್ಕೆ ಪ್ರತಿಕ್ರಿಯಿಸುತ್ತದೆಯೇ?",
      "ನಿಮ್ಮ ಮಗುವು ಕೂಗು ಶಬ್ದ ಮಾಡುತ್ತದೆಯೇ?",
      "ನಿಮ್ಮ ಮಗುವು ಧ್ವನಿಗಳಿಗೆ ನಗುತ್ತದೆಯೇ?",
    ],
    "3-6 months": [
      "ಮಗು ಶಬ್ದದ ಕಡೆ ತಲೆ ತಿರುಗಿಸುತ್ತದೆಯಾ?",
      "ಮಗು ನಗುತ್ತದೆಯೇ?",
      "ಮಗು ಸಂಗೀತಕ್ಕೆ ಪ್ರತಿಕ್ರಿಯೆ ನೀಡುತ್ತದೆಯಾ?",
    ],
    "6-9 months": [
      "ನಿಮ್ಮ ಮಗು ಶಬ್ದಗಳ ವ್ಯತ್ಯಾಸವನ್ನು ಗುರುತಿಸುತ್ತದೆಯೇ?",
      "ನಿಮ್ಮ ಮಗು ಹೆಸರನ್ನು ಕೇಳಿದಾಗ ತಿರುಗಿ ನೋಡುವುದಾ?",
      "ನಿಮ್ಮ ಮಗು 'ಬಾ-ಬಾ' ಅಥವಾ 'ಡಾ-ಡಾ' ಶಬ್ದಗಳನ್ನು ಬಳಸುತ್ತದೆಯೇ?",
    ],
    "9-12 months": [
      "ನಿಮ್ಮ ಮಗು ಸರಳ ಪದಗಳನ್ನು ಅರ್ಥ ಮಾಡಿಕೊಳ್ಳುತ್ತದೆಯೇ?",
      "ನಿಮ್ಮ ಮಗು ಸರಳ ಶಬ್ದಗಳನ್ನು ಅನುಕರಿಸುತ್ತದೆಯೇ?",
      "ನಿಮ್ಮ ಮಗು ವಸ್ತುಗಳನ್ನು ಹೆಸರಿಸಿದಾಗ ಸೂಚಿಸುತ್ತದೆಯೇ?",
    ],
    "1-2 years": [
      "ನಿಮ್ಮ ಮಗು ಸಾಮಾನ್ಯ ವಸ್ತುಗಳ ಹೆಸರನ್ನು ಅರ್ಥ ಮಾಡಿಕೊಳ್ಳುತ್ತದೆಯೇ?",
      "ನಿಮ್ಮ ಮಗು ಎರಡು ಪದಗಳನ್ನು ಸೇರಿಸಿ ಚಿಕ್ಕ ವಾಕ್ಯಗಳನ್ನು ರಚಿಸುತ್ತದೆಯೇ?",
      "ನಿಮ್ಮ ಮಗು ಹೆಸರನ್ನು ಮತ್ತೊಂದು ಕೋಣೆಯಿಂದ ಕರೆದರೆ ಪ್ರತಿಕ್ರಿಯಿಸುತ್ತದೆಯೇ?",
    ],
    "2-3 years": [
      "ನಿಮ್ಮ ಮಗು ಎರಡು ಹಂತದ ಸೂಚನೆಗಳನ್ನು ಅನುಸರಿಸುತ್ತದೆಯೇ?",
      "ನಿಮ್ಮ ಮಗು ಹೆಸರನ್ನು ದೂರದಿಂದ ಕರೆದಾಗ ಪ್ರತಿಕ್ರಿಯಿಸುತ್ತದೆಯೇ?",
      "ನಿಮ್ಮ ಮಗು 2-3 ಪದಗಳ ವಾಕ್ಯಗಳನ್ನು ಬಳಸುತ್ತದೆಯೇ?",
    ],
  },
};

const Questionnaire = () => {
  const [language, setLanguage] = useState("");
  const [age, setAge] = useState("");
  const [step, setStep] = useState(1);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [responses, setResponses] = useState([]);
  const [result, setResult] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const handleNext = () => setStep(2);

  const handleAnswer = (answer) => {
    const updatedResponses = [...responses, answer];
    setResponses(updatedResponses);

    if (currentQuestionIndex < questions[language][age].length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      const hasNo = updatedResponses.includes("no");
      setResult(hasNo ? "Refer, contact a nearby Audiologist" : "Pass");
      setOpenDialog(true);
    }
  };

  return (
    <Container sx={{ textAlign: "center", mt: 4, p: 3, maxWidth: "500px", bgcolor: "#f5f5f5", borderRadius: 3 }}>
      {step === 1 ? (
        <>
          <Typography variant="h5" sx={{ fontWeight: "bold", mb: 3, color: "#333" }}>📝 Questionnaire</Typography>
          <Box sx={{ mb: 3 }}>
            <FormControl fullWidth>

              <InputLabel>Language</InputLabel>
              <Select
                labelId="language-label"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                label="Select Language"
              >
                <MenuItem value="english">English</MenuItem>
                <MenuItem value="kannada">Kannada</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ mb: 3 }}>
            <FormControl fullWidth>
              <InputLabel>Select Age</InputLabel>
              <Select    labelId="Age-label"      label="Select Age" value={age} onChange={(e) => setAge(e.target.value)}>
                {Object.keys(questions.english).map((ageGroup) => (
                  <MenuItem key={ageGroup} value={ageGroup}>{ageGroup}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          {language && age && (
            <Button variant="contained" color="primary" onClick={handleNext} sx={{ mt: 2 }}>
              Next
            </Button>
          )}
        </>
      ) : (
        <Paper sx={{ p: 3, bgcolor: "#fff", borderRadius: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 3 }}>
            {questions[language][age][currentQuestionIndex]}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
            <Button variant="contained" color="success" onClick={() => handleAnswer("yes")}>Yes</Button>
            <Button variant="contained" color="error" onClick={() => handleAnswer("no")}>No</Button>
          </Box>
        </Paper>
      )}

      {/* Dialog for displaying results */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Test Result</DialogTitle>
        <DialogContent>
          <Typography sx={{ color: result === "Pass" ? "green" : "red", fontWeight: "bold" }}>{result}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => window.location.reload()} color="primary">OK</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Questionnaire;
